import {
  WheelPicker as NcdaiWheelPicker,
  WheelPickerWrapper,
} from '@ncdai/react-wheel-picker';
import '@ncdai/react-wheel-picker/style.css';
import React from 'react';

interface WheelPickerItem {
  id: string;
  label: string;
  avatar?: string;
}

interface WheelPickerProps {
  items: WheelPickerItem[];
  value: string | null;
  onChange: (id: string) => void;
  disabled?: boolean;
  className?: string;
}

const WheelPicker: React.FC<WheelPickerProps> = ({
  items,
  value,
  onChange,
  disabled: _disabled = false,
  className = '',
}) => {
  if (items.length === 0) {
    return (
      <div className={`relative ${className}`}>
        <div className="w-full h-48 bg-gray-50 border border-gray-200 rounded-lg flex items-center justify-center text-gray-500 text-sm">
          Нет участников
        </div>
      </div>
    );
  }

  return (
    <div className={`relative ${className}`}>
      <WheelPickerWrapper>
        <NcdaiWheelPicker
          options={items.map((item) => ({
            value: item.id,
            label: item.label,
          }))}
          value={value || ''}
          onValueChange={(selectedValue: string) => {
            onChange(selectedValue);
          }}
        />
      </WheelPickerWrapper>
    </div>
  );
};

export default React.memo(WheelPicker);
